import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { handleResponseError } from '../../utils/helpers/error';

export const getBacklinks = createAsyncThunk('backlinks.getBacklinks', async ({
  page, limit, excludeDomain = null, selectedCategory = null,
}, { rejectWithValue }) => {
  try {
    const queryParams = {
      page,
      limit,
    };

    if (excludeDomain) {
      queryParams.excludeDomain = excludeDomain;
    }

    if (selectedCategory) {
      queryParams.selectedCategory = selectedCategory._id;
    }

    const { data: { backlinks, totalDocs, domainBacklinks } } = await api.backlinks.getBacklinks(queryParams);
    return {
      backlinks,
      totalDocs,
      domainBacklinks,
    };
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const addBacklink = createAsyncThunk('backlinks.addBacklink', async ({
  domain, categories, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { newBacklink, message } } = await api.backlinks.addBacklink({
      domain,
      categories,
    });
    onSuccess(message);
    return newBacklink;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});

export const deleteBacklinks = createAsyncThunk('backlinks.deleteBacklinks', async ({
  ids, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { message } } = await api.backlinks.deleteBacklinks(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});
